export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9345.61c04d6d.jpg";